<script setup>
import { BaseDivider, BaseIcon } from '@edsights/ui-core';
import { computed, defineProps, defineEmits } from 'vue';

const props = defineProps({
    startFrom: {
        type: String,
        validator: (value) => {
            return ['template', 'scratch', 'past_campaign'].includes(value);
        }
    }
});

const startingFromText = computed(() => {
    return (
        {
            template: 'Template Library',
            scratch: 'Start from Scratch',
            past_campaign: 'Past Custom Campaign'
        }[props.startFrom] ?? ''
    );
});

defineEmits(['previousStep']);
</script>

<template>
    <div>
        <div class="campaign-form-header">
            <div @click="$emit('previousStep')" class="campaign-form-header__back-button">
                <BaseIcon icon="arrowleft" /> Back to Options
            </div>
            <span>Creating campaign from: <b>{{ startingFromText }}</b></span>
        </div>
        <BaseDivider />
    </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';

.campaign-form-header {
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
    width: 100%;

    &__back-button {
        display: flex;
        align-items: center;
        gap: 1rem;
        cursor: pointer;
        color: $edsights-blue;
        font-weight: bold;
        margin-right: 5rem;

        :deep(.pi) {
            display: flex;
            align-items: center;
            color: $edsights-blue;
            font-size: 1.2rem;
        }
    }
}
</style>
